import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link, useParams } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";

function AllPosition() {
  const params = useParams();
  const pageID = params.id;
  const [pageData, setPageData] = useState({});
  const [message, setMessage] = useState();
  const [positions, setPositions] = useState([]);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getAllPositionData(pageID);
    getPageData(pageID);
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllPositionData = async (pageID) => {
    const resultSendRequestGetPageData = await sendRequestGetAllPositionData(
      pageID
    );
    if (!resultSendRequestGetPageData) {
      return false;
    }

    setPositions(resultSendRequestGetPageData);
  };

  const sendRequestGetAllPositionData = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/position/manage/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const getPageData = async (pageID) => {
    setPageData(await sendRequestGetPageData(pageID));
  };

  const sendRequestGetPageData = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/manage/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const deletePosition = async (positionID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    if (await sendRequestDeletePosition(positionID)) {
      await getAllPositionData();
    }
  };

  const sendRequestDeletePosition = async (positionID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/position/manage/" + positionID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const generateTagPositions = (positions) => {
    return positions.map((position, index) => {
      return (
        <tr>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(position.pos_id)}</td>
          <td>{helpersNumbers.toPersianNum(position.pos_priority)}</td>
          <td>{helpersNumbers.toPersianNum(position.pos_count)}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(position.pos_base_price)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(position.pos_price)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                position.pos_alternative_price
              )
            )}
          </td>
          <td style={{ letterSpacing: "2px" }}>
            {helpersNumbers.toPersianNum(position.pos_size)}
          </td>
          <td>
            <div dir="ltr" className="text-center">
              {position.pos_active ? (
                <span className="badge badge-success">فعال</span>
              ) : (
                <span className="badge badge-danger">غیرفعال</span>
              )}
            </div>
          </td>
          <td dir="ltr">{position.pos_tag_html_id}</td>
          <td>
            <span className="pl-2">
              <button
                className="btn btn-info"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(
                    `<div class="hil-banner-advertise" id="${position.pos_tag_html_id}"></div>`
                  );
                  alert("تگ html کپی شد.");
                }}
              >
                <i className="fas fa-copy"></i>
              </button>
            </span>
            <span className="pl-2">
              <Link
                to={`/manage/position/edit/${position.pos_id}`}
                className="btn btn-success"
              >
                <i className="fa fa-edit"></i>
              </Link>
            </span>

            <span className="pl-2">
              <span
                className="btn btn-danger"
                onClick={() => deletePosition(position.pos_id)}
              >
                <i className="fa fa-trash"></i>
              </span>
            </span>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span>جایگاه های صفحه </span>
                  <span className="pr-2 text-info">{pageData.pag_title}</span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-2">
                <div className="d-flex justify-content-between">
                  <Link
                    className="text-white"
                    to={`/manage/position/add/${pageID}`}
                  >
                    <div className="btn btn-success">
                      <span className="pl-2">
                        <i
                          className="fa fa-plus text-white"
                          aria-hidden="true"
                        ></i>
                      </span>
                      <span>
                        <span className="text-white">
                          اضافه کردن جایگاه نمایش تبلیغ
                        </span>
                      </span>
                    </div>
                  </Link>

                  {pageData !== null ? (
                    <Link
                      to={`/manage/page/all/${pageData.pag_web_site_publisher_id}`}
                    >
                      <div className="btn btn-primary">
                        <span>
                          <span className="text-white">بازگشت</span>
                        </span>
                        <span className="pr-2">
                          <i
                            className="fas fa-arrow-left"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره</td>
                      <td>اولویت</td>
                      <td>تعداد بنر در جایگاه</td>
                      <td>مبلغ پایه</td>
                      <td>مبلغ</td>
                      <td>مبلغ بنر جایگزین</td>
                      <td>اندازه (ارتفاع - عرض)</td>
                      <td>وضعیت</td>
                      <td>id تگ جایگاه</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {positions.length != 0 ? (
                      generateTagPositions(positions)
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPosition;
